import { css } from '@emotion/react';

import { ThemeTokens } from '../shared/styles';

const { fontWeights, media } = ThemeTokens;

export const textMd = css`
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0;
  font-weight: ${fontWeights.normal};
  font-style: normal;
  margin: 0;
`;

export const textSm = css`
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  font-weight: ${fontWeights.normal};
  font-style: normal;
  margin: 0;
`;

export const textXs = css`
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  font-weight: ${fontWeights.normal};
  font-style: normal;
  margin: 0;
`;

export const text2xs = css`
  font-size: 10px;
  line-height: 24px;
  letter-spacing: 0;
  font-weight: ${fontWeights.normal};
  font-style: normal;
  margin: 0;

  ${media.sm} {
    font-size: 10px;
    line-height: 14px;
  }

  ${media.md} {
    font-size: 10px;
    line-height: 14px;
  }
`;

// Font weight styles
export const textNormal = css`
  font-weight: ${fontWeights.normal};
`;

export const textSemibold = css`
  font-weight: ${fontWeights.medium};
`;

export const textBold = css`
  font-weight: ${fontWeights.bold};
`;

export const textExtrabold = css`
  font-weight: ${fontWeights.bolder};
`;

// Modifier styles
export const textUppercase = css`
  text-transform: uppercase;
`;

// Text wrap styles (reuse from Heading styles)
export const wrapPretty = css`
  text-wrap: pretty;
`;

export const wrapBalance = css`
  text-wrap: balance;
`;

export const wrapNowrap = css`
  text-wrap: nowrap;
`;

export const wrapWrap = css`
  text-wrap: wrap;
`;

export const wrapStable = css`
  text-wrap: stable;
`;

// Style mapping objects
export const textSizeStyles = {
  md: textMd,
  sm: textSm,
  xs: textXs,
  '2xs': text2xs,
};

export const textFontWeightStyles = {
  normal: textNormal,
  semibold: textSemibold,
  bold: textBold,
  extrabold: textExtrabold,
};

export const textWrapStyles = {
  pretty: wrapPretty,
  balance: wrapBalance,
  nowrap: wrapNowrap,
  wrap: wrapWrap,
  stable: wrapStable,
};
